const QueryBuilder = (queryObj = false) => {
    if (!queryObj) {
        return '';
    }

    let queryString = '?';
    let queryPairs = [];
    for (let [key, value] of Object.entries(queryObj)) {
        if (Array.isArray(value)) {
            value.forEach((val) => {
                queryPairs.push(`${key}=${val}`);
            });
        } else {
            queryPairs.push(`${key}=${value}`);
        }
    }
    queryString += queryPairs.join('&');
    return queryString;
};

export default QueryBuilder;
